/** Bound the whole operation, including native bridges and token acquisition. */
export const withTimeout = <T,>(promise: Promise<T>, timeoutMs: number, onTimeout?: () => void): Promise<T> =>
  new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Request timed out'));
      onTimeout?.();
    }, timeoutMs);

    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      },
    );
  });
